export const quickTableConfig = {
  availablePageSizes: [10, 15, 20, 30, 50, 100, 200],
};
